import type {
  RefereeControllerCreateData,
  RefereeControllerCreateResponse,
  RefereeControllerFindAllData,
  RefereeControllerFindAllResponse,
  RefereeControllerRemoveData,
  RefereeControllerRemoveResponse,
  RefereeControllerUpdateData,
  RefereeControllerUpdateResponse,
} from '~/api';
import {
  refereeControllerCreate,
  refereeControllerFindAll,
  refereeControllerRemove,
  refereeControllerUpdate,
} from '~/api';
import { heyApiQuery } from '~/utils/api';

import api from '..';

export const referees = api.injectEndpoints({
  endpoints: builder => ({
    paginateReferees: builder.query<RefereeControllerFindAllResponse, RefereeControllerFindAllData['query']>({
      queryFn: query => heyApiQuery(() => refereeControllerFindAll({ query })),
      providesTags: result =>
        result?.success
          ? [
              ...result.data.items.map(({ id }: { id: number }) => ({ type: 'PLAYER', id }) as const),
              { type: 'REFEREE', id: 'ALL' },
            ]
          : [{ type: 'REFEREE', id: 'ALL' }],
    }),
    createReferee: builder.mutation<RefereeControllerCreateResponse, { params: RefereeControllerCreateData['body'] }>({
      queryFn: async ({ params }) => heyApiQuery(() => refereeControllerCreate({ body: params })),
      invalidatesTags: () => [{ type: 'REFEREE', id: 'ALL' }],
    }),
    updateReferee: builder.mutation<
      RefereeControllerUpdateResponse,
      { id: RefereeControllerUpdateData['path']['id']; params: RefereeControllerUpdateData['body'] }
    >({
      queryFn: async ({ id, params }) => heyApiQuery(() => refereeControllerUpdate({ path: { id }, body: params })),
      invalidatesTags: () => [{ type: 'REFEREE', id: 'ALL' }],
    }),
    deleteReferee: builder.mutation<RefereeControllerRemoveResponse, RefereeControllerRemoveData['path']['id']>({
      queryFn: id => heyApiQuery(() => refereeControllerRemove({ path: { id } })),
      invalidatesTags: () => [{ type: 'REFEREE', id: 'ALL' }],
    }),
  }),
  overrideExisting: false,
});
